export default __webpack_public_path__ + "media/design-system/avatar/assets/default_partner-2769ff846b806bd3281d78d542778a5d.svg";